export default __webpack_public_path__ + "static/media/desktop_ellipse_3.9742cd9f.svg";